import type React from "react"
import { Input } from "@/components/ui/input"
import { Slider } from "@/components/ui/Slider"

interface WeightSliderProps {
  items: string[]
  weights: number[]
  onChange: (newWeights: number[]) => void
}

export function WeightSlider({ items, weights, onChange }: WeightSliderProps) {
  const handleSliderChange = (index: number) => (value: number[]) => {
    updateWeight(index, value[0])
  }

  const handleInputChange = (index: number) => (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = Number.parseFloat(e.target.value)
    if (!isNaN(value) && value >= 0 && value <= 100) {
      updateWeight(index, value)
    }
  }

  const updateWeight = (index: number, value: number) => {
    const newWeights = [...weights]
    newWeights[index] = value / 100 // Convert percentage to decimal

    // Normalize weights
    const sum = newWeights.reduce((a, b) => a + b, 0)
    const normalizedWeights = newWeights.map((w) => w / sum)

    onChange(normalizedWeights)
  }

  return (
    <div className="space-y-6">
      {items.map((item, index) => (
        <div key={item} className="space-y-2">
          <div className="flex justify-between items-center">
            <span className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70">
              {item}
            </span>
            <Input
              //type="number"
              //min="0"
              //max="100"
              //step="0.1"
              value={(weights[index] * 100).toFixed(1)}
              onChange={(e) => handleInputChange(index)(e)}
              className="w-16 text-center"
            />
          </div>
          <Slider
            value={[weights[index] * 100]}
            min={0}
            max={100}
            step={0.1}
            onValueChange={handleSliderChange(index)}
            className="[&_[role=slider]]:h-4 [&_[role=slider]]:w-4"
          />
        </div>
      ))}
    </div>
  )
}

